// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.ts.
import type BaseBackendService from '../BaseBackendService';
import {
  DiscardInvestorStatementResponse,
  GenerateInvestorStatementBatchResponse,
  InvestorStatementBatch,
  InvestorStatementEmailTemplateData,
  InvestorStatementItem,
} from '../../models/admin/InvestorStatement';

export const adminBackendServiceInvestorStatementMixin = {
  generateInvestorStatementBatch(
    investorExternalId: string,
  ): Promise<GenerateInvestorStatementBatchResponse> {
    return this.authApiMutateAuthed(
      'investor-statements/batches',
      'POST',
      { investorExternalId },
      (json) => json.data,
    );
  },

  getInvestorStatementBatch(batchId: string): Promise<InvestorStatementBatch> {
    return this.authApiGetAuthed(
      `investor-statements/batches/${batchId}`,
      'Unable to retrieve investor statement batch',
      (json) => json.data,
    );
  },

  getInvestorStatementViewUrl(itemId: string): Promise<string> {
    return this.authApiGetAuthed(
      `investor-statements/items/${itemId}/view`,
      'Unable to generate statement view URL',
      (json) => json.data.url,
    );
  },

  confirmInvestorStatement(itemId: string): Promise<InvestorStatementItem> {
    return this.authApiMutateAuthed(
      `investor-statements/items/${itemId}/confirm`,
      'POST',
      undefined,
      (json) => json.data,
    );
  },

  discardInvestorStatement(itemId: string): Promise<DiscardInvestorStatementResponse> {
    return this.authApiMutateAuthed(
      `investor-statements/items/${itemId}/discard`,
      'POST',
      undefined,
      (json) => json.data,
    );
  },

  sendInvestorStatementEmail(
    itemId: string,
    subject: string,
    html: string,
  ): Promise<{ success: boolean }> {
    return this.authApiMutateAuthed(
      `investor-statements/items/${itemId}/send-email`,
      'POST',
      { subject, html },
      (json) => json.data,
    );
  },

  getInvestorStatementEmailTemplate(itemId: string): Promise<InvestorStatementEmailTemplateData> {
    return this.authApiGetAuthed(
      `investor-statements/items/${itemId}/email-template`,
      'Unable to fetch investor statement email template',
      (json) => json.data,
    );
  },
} satisfies ThisType<BaseBackendService>;
